import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { merge } from 'lodash'

// Import modules
import {
  authorization,
  beneficiary,
  business,
  context,
  configurations,
  customers,
  enumerations,
  forms,
  merchant,
  messages,
  modals,
  navigation,
  notifications,
  overview,
  partner,
  paymentJobs,
  statistics,
  steps,
  tickets,
  trace,
  transactions,
  users
} from '@/store/modules'

Vue.use(Vuex)

const initializeEnumerations = store => {
  ['batchStatuses', 'beneficiaryStatuses', 'channels', 'genders', 'phoneNumberTypes', 'salutations', 'ticketPriorities', 'ticketStatuses'].forEach(resource => store.dispatch('getEnumeration', { enumeration: resource }))
}

const store = new Vuex.Store({
  ...merge(messages, modals),
  modules: {
    authorization,
    beneficiary,
    business,
    context,
    configurations,
    customers,
    enumerations,
    forms,
    merchant,
    navigation,
    notifications,
    overview,
    partner,
    paymentJobs,
    statistics,
    steps,
    tickets,
    trace,
    transactions,
    users
  },
  plugins: [
    initializeEnumerations,
    createPersistedState({
      paths: ['authorization.credentials.refreshToken', 'authorization.permissions'],
      storage: window.sessionStorage
    }),
    createPersistedState({
      paths: ['context.context']
    })
  ]
})

export default store
